// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
/**
 * Propose au navigateur d'enregistrer un contenu produit dans l'onglet : facture,
 * graveur, ordre de fabrication, restitution d'un établissement.
 *
 * Le contenu arrive par le client axios, jamais par une ancre pointée sur la
 * route : les routes sont authentifiées par en-tête, et un lien nu partirait
 * sans le jeton.
 *
 * L'URL du blob est révoquée aussitôt le clic donné : la copie que le navigateur
 * garde pour cette URL porterait, pour un ordre de fabrication, le secret du
 * serveur. `deferredRevocationMs` laisse au navigateur le temps de lire le blob
 * avant la révocation ; il ne sert qu'aux fichiers qui ne portent pas de secret.
 */
export function saveFile(blob, fileName, { revocationDiffereeMs: deferredRevocationMs = 0 } = {}) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  if (deferredRevocationMs > 0) {
    setTimeout(() => URL.revokeObjectURL(url), deferredRevocationMs);
  } else {
    URL.revokeObjectURL(url);
  }
}
